<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div>Floors</div>
      <b-btn variant="primary btn-round" class="d-block" @click="floorCreate">
        <span class="ion ion-md-add"></span>&nbsp; Create floor
      </b-btn>
    </h4>

    <b-card no-body v-if="floorsNonLocal.length">
      <!-- Table -->
      <div class="table-responsive">
        <b-table
          id="floor"
          tbody-tr-class="floor-row"
          primary-key="id"
          :items="floorsNonLocal"
          :fields="fields"
          :striped="true"
          :bordered="true"
          class="card-table"
        >
          <template #cell(building_id)="data">
            <span v-text="buildingName(data.item.building_id)"></span>
            <span
              class="text-muted d-block"
              v-if="buildingTimezoneLabel(data.item.building_id)"
              v-text="buildingTimezoneLabel(data.item.building_id)"
            ></span>
          </template>

          <template #cell(status)="data">
            <b-badge variant="outline-info" v-if="+data.item.status === 0">Draft</b-badge>
            <b-badge variant="outline-success" v-if="+data.item.status === 1">Published</b-badge>
          </template>

          <template #cell(map_updated_at)="data">
            <span v-if="data.item.map_updated_at">{{ data.item.map_updated_at | appDateTime }}</span>
            <span class="text-danger" v-else>not created yet</span>
          </template>

          <template #cell(sort)="data">
            <span
              class="mr-2"
              @click="up(data.item)"
              v-if="floorsNonLocal[data.index - 1] && floorsNonLocal[data.index - 1].building_id === data.item.building_id"
            >
              <i class="ion ion-md-arrow-up"></i
            ></span>
            <span
              @click="down(data.item)"
              v-if="floorsNonLocal[data.index + 1] && floorsNonLocal[data.index + 1].building_id === data.item.building_id"
            >
              <i class="ion ion-md-arrow-down"></i
            ></span>
          </template>

          <!-- eslint-disable-next-line -->
          <template #cell(actions)="data">
            <b-btn variant="default btn-xs icon-btn md-btn-flat" title="Edit" @click="edit(data.item)"
              ><i class="ion ion-md-create"></i></b-btn
            >&nbsp;
            <b-btn variant="default btn-xs icon-btn md-btn-flat" title="Remove" @click="destroy(data.item)"
              ><i class="ion ion-md-close"></i
            ></b-btn>
          </template>
        </b-table>
      </div>
    </b-card>
    <div v-else class="text-big">
      Create your first floor here!

      <b-btn variant="primary btn-round ml-1" @click="floorCreate"> <span class="ion ion-md-add"></span>&nbsp; Create floor </b-btn>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import { isNumeric } from '@/utils/Helpers'
import Id from '@/utils/Id'
import { mapActions, mapGetters } from 'vuex'
import escape from 'lodash/escape'

export default {
  name: 'floors-list',
  data: () => ({
    fields: [
      { key: 'name', label: 'Floor name' },
      { key: 'building_id', label: 'Building' },
      { key: 'map_updated_at', label: 'Map updated at' },
      { key: 'status' },
      { key: 'sort', label: 'Order' },
      { key: 'actions', label: ' ', tdClass: 'text-center text-nowrap' }
    ]
  }),
  computed: {
    ...mapGetters('floor', ['floorsNonLocal']),
    ...mapGetters('building', ['getBuilding']),
    ...mapGetters('timezone', ['getTimezoneLabel'])
  },
  methods: {
    ...mapActions('floor', ['floorDestroy', 'floorsLoad', 'floorSave']),
    edit(floor) {
      this.$router.push({ name: 'floor-edit', params: { floorId: floor.id } })
    },
    buildingName(bId) {
      let building = this.getBuilding(bId)
      return building ? building.name : ''
    },
    buildingTimezoneLabel(bId) {
      let building = this.getBuilding(bId)
      return building && building.timezone ? this.getTimezoneLabel(building.timezone) : ''
    },
    floorCreate() {
      this.edit({ id: Id() })
    },
    getReplaceFloor(sort, buildingId) {
      return this.floorsNonLocal.find((f) => buildingId === f.building_id && sort === f.sort)
    },
    down(floor) {
      const replaceFloor = this.getReplaceFloor(floor.sort - 1, floor.building_id)
      let promise = Promise.resolve(true)
      if (replaceFloor) {
        promise = this.floorSave({ floor: { id: replaceFloor.id, sort: isNumeric(floor.sort) ? floor.sort : 0 } })
      }
      promise.then(() => {
        this.floorSave({ floor: { id: floor.id, sort: isNumeric(floor.sort) ? floor.sort - 1 : 0 } })
      })
    },
    up(floor) {
      const replaceFloor = this.getReplaceFloor(floor.sort + 1, floor.building_id)
      let promise = Promise.resolve(true)
      if (replaceFloor) {
        promise = this.floorSave({ floor: { id: replaceFloor.id, sort: isNumeric(floor.sort) ? floor.sort : 0 } })
      }
      promise.then(() => {
        this.floorSave({ floor: { id: floor.id, sort: isNumeric(floor.sort) ? floor.sort + 1 : 0 } })
      })
    },
    destroy(floor) {
      const message = `
      Please confirm that you want to delete the '<b>${escape(floor.name)}</b>' floor:<br>
       - All entities on the floor will be deleted, except for employees.<br>
       - Employees will be removed from the map, but you can assign them <a href="/employees">manually later</a>.<br>
       - This action cannot be undone.<br>`

      this.$appToast.question(message).then(() => {
        this.floorDestroy(floor)
      })
    }
  }
}
</script>

<style scoped></style>
